<script lang="ts">
import type { ITreeViewNode } from "./TreeView/iTreeViewNode";

  // component params
  export let label:string | null
  export let text:string | null
  export let children:Array<ITreeViewNode>
  export let depth:number = 0 // INTERNAL: maintain depth
  let classAttribute:string = "";
	export { classAttribute as class };
 
  // maintain expansion state
  // ... default to false on first occurance
  let expanded:boolean = label == null;
  $: arrowDown = expanded;
  const toggleExpansion = () => expanded = !expanded;
 </script>
 
{#if label != null}
 <ul class={classAttribute || ""}>
   <li>
    <span class="cursor-pointer" on:click={toggleExpansion}>
      <span class="arrow text-darkFore" class:arrowDown>&#x23F5</span>
      <span class="text-darkFore">{label}</span>
    </span>
    {#if expanded}
      {#if text}
        <div class="indent text-darkFore">{text}</div>
      {/if}
      {#each children as child}
        <svelte:self class="indent" label={child.treeViewNodeLabel} text={child.treeViewNodeText} children={child.treeViewNodeChildren} depth={depth + 1}/>
      {/each}
    {/if}
   </li>
 </ul>
{:else}
  <div>
    {#if text}
      <div class="indent text-darkFore">{text}</div>
    {/if}
    {#each children as child}
      <svelte:self label={child.treeViewNodeLabel} text={child.treeViewNodeText} children={child.treeViewNodeChildren} depth={depth + 1}/>
    {/each}
  </div>
{/if}
 
 <style>
  ul {
    list-style-type: none;   /* nix traditional list bullets */
    /*user-select:     none;*/   /* disable selectable text */
  }

  .indent {
    padding-left: 1.2rem; /* lesser list indendation */
  }

  .arrow {
    display:             inline-block;
  }
  
  .arrowDown {
    transform: rotate(90deg);
  }
 </style>
 